module.exports = __webpack_public_path__ + "static/media/nophoto.12c7326e.png";